import { render, staticRenderFns } from "./Category-Change-Status.vue?vue&type=template&id=90300fe0&scoped=true"
import script from "./Category-Change-Status.vue?vue&type=script&lang=js"
export * from "./Category-Change-Status.vue?vue&type=script&lang=js"
import style0 from "./Category-Change-Status.vue?vue&type=style&index=0&id=90300fe0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90300fe0",
  null
  
)

export default component.exports